import { Component, Input, Output, EventEmitter, Inject, Injectable } from '@angular/core';
import { MenuLink } from '../menu-link.model';
import { LocaleAwareBaseComponent } from './../../../../seo/locale-aware-base.component';

@Injectable()
@Component({
  selector: 'app-menu-item-base',
  templateUrl: './menu-item-base.component.html',
  styleUrls: ['./menu-item-base.component.scss']
})

export class MenuItemBaseComponent extends LocaleAwareBaseComponent {
  @Input() item: MenuLink;
  @Input() children: MenuLink[] = [];
  @Input() currentRoute: string;
  @Output() toggleMobileMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  private toggle: boolean = true;
  public isOpen: boolean = false;
  public activeLink: boolean;

  constructor(
    @Inject('WINDOW') public window: any
  ) {
    super();
  }

  public toggleMenu(): void {
    if (this.window) {
      setTimeout(
        () => {
          if (this.window.innerWidth < 960) {
            this.toggle = !this.toggle;
            this.toggleMobileMenu.next(this.toggle);
          }
        },
        200
      );
    }
  }

  public isItemLinkActive(item: MenuLink, children: MenuLink[]): boolean {
    if (item.link === this.currentRoute) {
      return true;
    } else if (this.currentRoute.includes(item.link) && item.link !== '/') {
      return true;
    }

    if (children.length > 0) {
      if (children.find((child) => this.currentRoute.includes(child.link))) {
        return true;
      }
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component.ts